enum LoginType {
  SELF,
  ON_BEHALF,
  SELF_RELOGIN,
  RELOGIN_ON_BEHALF,
  SIGNOUT_ON_BEHALF,
}

export default LoginType;
